// Stroke icons for /welcome (from the prototype). Decorative: aria-hidden.
const Svg = ({ size = 24, width = 2, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={width}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
)

export const IconCheck = ({ size = 18, width = 2.6 }) => (
  <Svg size={size} width={width}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </Svg>
)

export const IconArrow = () => (
  <Svg size={20} width={2.2}>
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </Svg>
)

export const IconBack = () => (
  <Svg size={20} width={2.2}>
    <path d="M15 18l-6-6 6-6" />
  </Svg>
)

export const IconClose = ({ size = 18 }) => (
  <Svg size={size} width={2.2}>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </Svg>
)

export const IconMail = () => (
  <Svg size={34} width={1.8}>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M3.5 7l8.5 6 8.5-6" />
  </Svg>
)

export const IconEye = ({ off }) => (
  <Svg size={22}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
    {off && <path d="M3 3l18 18" />}
  </Svg>
)

export const IconPin = ({ size = 18 }) => (
  <Svg size={size}>
    <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </Svg>
)

export const IconGlobe = ({ size = 18 }) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18z" />
  </Svg>
)

export const IconCamera = () => (
  <Svg size={34} width={1.8}>
    <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
    <circle cx="12" cy="13.5" r="3.5" />
  </Svg>
)

export const IconUser = ({ size = 30 }) => (
  <Svg size={size}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21v-1a8 8 0 0 1 16 0v1" />
  </Svg>
)

export const IconSparkle = ({ size = 13 }) => (
  <Svg size={size} width={2.4}>
    <path d="M12 3l1.8 4.7 4.7 1.8-4.7 1.8L12 16l-1.8-4.7-4.7-1.8 4.7-1.8z" />
  </Svg>
)

export const IconChat = ({ size = 22 }) => (
  <Svg size={size}>
    <path d="M21 12a8 8 0 0 1-11.8 7L4 20l1.1-4.6A8 8 0 1 1 21 12z" />
  </Svg>
)

export const IconChevronUp = () => (
  <Svg size={20} width={2.2}>
    <path d="M6 15l6-6 6 6" />
  </Svg>
)

export const INTENT_ICONS = {
  idea: (
    <Svg>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M12 3a6 6 0 0 0-3.6 10.8c.7.6 1.1 1.3 1.1 2.2h5c0-.9.4-1.6 1.1-2.2A6 6 0 0 0 12 3z" />
    </Svg>
  ),
  join: (
    <Svg>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M19 8v6" />
      <path d="M16 11h6" />
    </Svg>
  ),
  startup: (
    <Svg>
      <path d="M5 15c-1.5 1.5-2 5-2 5s3.5-.5 5-2" />
      <path d="M9 15l-3-3c1.2-4.2 4.8-8.4 12-9-.6 7.2-4.8 10.8-9 12z" />
      <circle cx="14.5" cy="9.5" r="1.6" />
    </Svg>
  ),
  jobs: (
    <Svg>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </Svg>
  ),
}

export const SKILL_ICONS = {
  dev: (
    <Svg>
      <path d="M8 8l-4 4 4 4" />
      <path d="M16 8l4 4-4 4" />
      <path d="M13.5 5l-3 14" />
    </Svg>
  ),
  design: (
    <Svg>
      <path d="M12 19l7-7 3 3-7 7z" />
      <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18z" />
      <path d="M2 2l7.6 7.6" />
      <circle cx="11" cy="11" r="2" />
    </Svg>
  ),
  mkt: (
    <Svg>
      <path d="M3 11v2a1 1 0 0 0 1 1h3l6 4V6L7 10H4a1 1 0 0 0-1 1z" />
      <path d="M17 9a4 4 0 0 1 0 6" />
      <path d="M19.5 6.5a8 8 0 0 1 0 11" />
    </Svg>
  ),
  biz: (
    <Svg>
      <path d="M10 13a5 5 0 0 0 7.1 0l3-3A5 5 0 0 0 13 2.9l-1.5 1.5" />
      <path d="M14 11a5 5 0 0 0-7.1 0l-3 3A5 5 0 0 0 11 21.1l1.5-1.5" />
    </Svg>
  ),
  sales: (
    <Svg>
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M15 7h6v6" />
    </Svg>
  ),
  product: (
    <Svg>
      <path d="M12 3l9 5-9 5-9-5z" />
      <path d="M3 13l9 5 9-5" />
    </Svg>
  ),
}
